import { AloftArea, AloftPrice, PairedCostFeatures } from '@aloft/toolkit-shared';

import { Tkv2PairedCostSummaryInterfaceV2 } from '../../types.ts';

const getPriceChartDataFromFeature = (features?: PairedCostFeatures) => {
  const siteSize = features?.site?.siteValue?.sqft.toSqFt().getUnitAmount();
  const siteCostPerSF = features?.site?.siteValue?.costPerSqft?.toDollarLike();
  return { siteSize, siteCostPerSF };
};

export const getSiteSizeVsPriceChartData = (
  props: Tkv2PairedCostSummaryInterfaceV2 | null,
  compSequence: string[] | undefined,
  siteSizes: Record<string, AloftArea | undefined>,
  siteCostPerSFs: Record<string, AloftPrice | undefined>,
) => {
  const data: {
    siteName: string;
    siteSize: number | undefined;
    siteCostPerSF: number | undefined;
  }[] = [];

  if (props) {
    const subjectFeatures = props.results?.subject?.features;
    data.push({ siteName: 'SUB', ...getPriceChartDataFromFeature(subjectFeatures) });

    props.compSequence.forEach((compId, idx) => {
      const compFeatures = props.results.comps[compId]?.features;
      data.push({ siteName: `CP${idx + 1}`, ...getPriceChartDataFromFeature(compFeatures) });
    });
  } else if (compSequence) {
    data.push({
      siteName: 'SUB',
      siteSize: siteSizes.subject?.toSqFt().getUnitAmount(),
      siteCostPerSF: siteCostPerSFs.subject?.toDollarLike(),
    });

    compSequence.forEach((compId, idx) => {
      data.push({
        siteName: `CP${idx + 1}`,
        siteSize: siteSizes[compId]?.toSqFt().getUnitAmount(),
        siteCostPerSF: siteCostPerSFs[compId]?.toDollarLike(),
      });
    });
  }

  return data.sort((a, b) => (a.siteSize ?? 0) - (b.siteSize ?? 0));
};
